$(document).on("ready", function () {
  $("#productdetails__sliderthumbs").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    asNavFor: "#productdetails__slider",
    swipe: true,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 599,
        settings: {
          slidesToShow: 4,
        },
      },
    ],
  });
  $("#productdetails__slider").slick({
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    asNavFor: "#productdetails__sliderthumbs",
    focusOnSelect: true,
  });
});

jQuery(".cart_icon").click(function () {
  jQuery("html").addClass("drawer-open");
});

jQuery(".cart-drawer__close,.drawer-overlap").click(function () {
  jQuery("html").removeClass("drawer-open");
  jQuery("body").removeClass("drawer-open");
});

jQuery(".productdetails__addtocart_quickcart_atc").click(function () {
  jQuery("html").addClass("popup-active");
});

jQuery(".fader").click(function () {
  jQuery("html").removeClass("popup-active");

  jQuery(".fader").removeClass("active");

  jQuery(".popup-wrapper").removeClass("matched-popup");
  // Find the matching .popup-wrapper by data-product-popup-id-wrapper
  $(".popup-wrapper").each(function () {
    $(this).removeClass("matched-popup");
  });
});

$(".product_form_options_singleCart").click(function (e) {
  e.preventDefault();
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: $(this).find(".shopify-product-form").serialize(),
    success: function (data) {
      $(".cart-drawer__footer").removeClass("hidden");
      $(".cart-drawer__header-info").removeAttr("hidden");
      $(".empty_cart_msg").remove();
      get_cart_details();
      console.log("Cart Added product__addtocart_wrapper");
      // jQuery('body').addClass('drawer-open');
      // console.log(data);
      // $('.cart-drawer__image img').attr('src',data.featured_image.url);
      // $('.cart-drawer__url').html(data.product_title + ' - ' + data.variant_title + ' - ' + data.price );
      // $('.cart-drawer__price').html(data.final_line_price);
      // $('.cart-drawer__qty-input').attr('value',data.quantity);
    },
    error: "addToCartFail",
  });
});

$(".popupAddToCartButtonClick button#add-to-cart").click(function (e) {
  e.preventDefault();

  // Find the closest parent form of the clicked button
  const form = $(this).closest("form");

  // Serialize the form data and send it via AJAX
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: form.serialize(),
    success: function (data) {
      $(".cart-drawer__footer").removeClass("hidden");
      $(".cart-drawer__header-info").removeAttr("hidden");
      $(".empty_cart_msg").remove();
      get_cart_details(); // Assuming this function updates the cart drawer
      console.log("Product added to cart successfully.");
    },
    error: function () {
      console.error("Failed to add the product to the cart.");
    },
  });
});

$(".MyProductDetailsAddToCart").click(function (e) {
  e.preventDefault();
  console.log("Cart Added");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: $(".shopify-product-form").serialize(),
    success: function (data) {
      $(".cart-drawer__footer").removeClass("hidden");
      $(".cart-drawer__header-info").removeAttr("hidden");
      $(".empty_cart_msg").remove();
      get_cart_details();
      console.log("Cart Added addcart__button");
      // jQuery('body').addClass('drawer-open');
      // console.log(data);
      // $('.cart-drawer__image img').attr('src',data.featured_image.url);
      // $('.cart-drawer__url').html(data.product_title + ' - ' + data.variant_title + ' - ' + data.price );
      // $('.cart-drawer__price').html(data.final_line_price);
      // $('.cart-drawer__qty-input').attr('value',data.quantity);
    },
    error: "addToCartFail",
  });
});

function get_cart_details() {
  fetch("/?section_id=cart-drawyer")
    .then((response) => response.text())
    .then((cartData) => {
      var cart_html = $(cartData);
      var cart_items = $(".cart-drawer__content", cart_html);
      var cart_count = $(".cart-drawer__count", cart_html);
      var cart_subtotal = $(".cart-drawer__total-amount", cart_html);
      $(".cart-drawer__content").replaceWith(cart_items);
      $(".cart-drawer__count").replaceWith(cart_count);
      $(".cart-drawer__total-amount").replaceWith(cart_subtotal);
      jQuery("body").addClass("drawer-open");
    });
}

function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function change_qty(e) {
  var o = $(e).attr("data-id"),
    t = $(e).val(),
    i = {
      updates: {},
    };
  (i.updates[o] = t),
    jQuery.ajax({
      type: "POST",
      url: "/cart/update.js",
      data: $(".drawer_form").serialize(),
      dataType: "json",
      success: function (e) {
        console.log(e.items_subtotal_price),
          (product_total_price = e.items_subtotal_price);
        var t = e.items;
        console.log(e);
        var i = e.total_price;
        i /= 100;
        var n = e.item_count;
        if (n < 1) {
          $(".cart-drawer__footer").addClass("hidden");
          $(".cart-drawer__header-info").attr("hidden", true);
          $(".cart-drawer__header").append(
            '<div class="empty_cart_msg">Your Cart is Empty!</div>'
          );
        }
        0 == n
          ? $(".cart-drawer__no-item").addClass("cart-drawer__no-item_visible")
          : $(".cart-drawer__no-item").removeClass(
              "cart-drawer__no-item_visible"
            ),
          $(".cart-drawer__count").html(n),
          $(".nav__cart-count").html(n),
          $(".cart-drawer__total-amount").html(
            get_currency + numberWithCommas(i.toFixed(2))
          ),
          jQuery.each(t, function (e, t) {
            var i = t.final_line_price;
            (i /= 100),
              t.key == o &&
                $(".cart-drawer__price[data-id='" + t.key + "']").html(
                  get_currency + numberWithCommas(i.toFixed(2))
                );
          });
      },
    });
}

$(document).on("click", ".minus-btn", function (e) {
  e.preventDefault();
  var t = $(this).closest("div").find("input"),
    i = parseInt(t.val());
  1 < i ? --i : ((i = 1), $(this).attr("disabled", true)),
    t.val(i),
    change_qty(t);
});
$(document).on("click", ".plus-btn", function (e) {
  e.preventDefault();
  var t = $(this).closest("div").find("input"),
    i = parseInt(t.val());
  i < 100 ? (i += 1) : (i = 100),
    t.val(i),
    $(".minus-btn").attr("disabled", false),
    change_qty(t);
});

$(document).on("click", ".cart-drawer__remove-url", function (e, el) {
  e.preventDefault();
  var variant_id = $(this).attr("data-id");
  console.log(variant_id);
  var data = { updates: {} };
  data.updates[variant_id] = "0";
  jQuery.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: data,
    dataType: "json",
    success: function (e) {
      console.log(e),
        console.log(e.items_subtotal_price),
        (product_total_price = e.items_subtotal_price);
      e.items;
      var t = e.total_price;
      t /= 100;
      var i = e.item_count;
      if (i < 1) {
        $(".cart-drawer__footer").addClass("hidden");
        $(".cart-drawer__header-info").attr("hidden", true);
        $(".cart-drawer__header").append(
          '<div class="empty_cart_msg">Your Cart is Empty!</div>'
        );
      }
      0 == i
        ? $(".cart-drawer__no-item").addClass("cart-drawer__no-item_visible")
        : $(".cart-drawer__no-item").removeClass(
            "cart-drawer__no-item_visible"
          ),
        $(".cart-drawer__count").html(i),
        $(".nav__cart-count").html(i),
        $(".cart-drawer__total-amount").html(
          get_currency + numberWithCommas(t.toFixed(2))
        ),
        i <= 0 && $(".my__custom_cart_drawer").addClass("no_item");
    },
  }),
    $(this).parent().parent().remove();
});

$(document).on(
  "click",
  ".productdetails__addtocart_quickcart_atc",
  function () {
    $(".fader").addClass("active");
    // Get the data-variant-product-popup-id of the clicked button
    var popupId = $(this).data("variant-product-popup-id");

    // Find the matching .popup-wrapper by data-product-popup-id-wrapper
    $(".popup-wrapper").each(function () {
      if ($(this).data("product-popup-id-wrapper") === popupId) {
        // Add a class to the matching .popup-wrapper
        $(this).addClass("matched-popup");
      }
    });
  }
);

$(document).on("click", ".popupdrawer__close", function () {
  $(".fader").removeClass("active");
  jQuery("html").removeClass("popup-active");
  jQuery("fader").removeClass("active");
  // Find the matching .popup-wrapper by data-product-popup-id-wrapper
  $(".popup-wrapper").each(function () {
    $(this).removeClass("matched-popup");
  });
});

$(document).on(
  "click",
  "button.header__icon-wrapper.tap-area.hidden-desk",
  function () {
    $("#mobile-menu-drawer").attr("open", true);
  }
);

$(document).on(
  "click",
  "button.drawer__close-button.drawer__close-button--block.tap-area",
  function () {
    $("#mobile-menu-drawer").removeAttr("open");
  }
);

/*
document.addEventListener("DOMContentLoaded", function () {
  const inputs = Array.from(
    document.querySelectorAll(".variant_groups input[type=radio]")
  );
  const select = document.querySelector(".variant_groups select");
  const options = select.children;
  const variantInput = document.getElementById("product_variant");
  const addToCartButton = document.querySelector("#add-to-cart"); // Replace with the actual button selector

  // Group inputs by their `name` attribute
  const optionGroups = inputs.reduce((groups, input) => {
    const groupName = input.name;
    if (!groups[groupName]) {
      groups[groupName] = [];
    }
    groups[groupName].push(input);
    return groups;
  }, {});

  // Function to update the variant ID and button state
  function updateVariantIdAndButtonState() {
    const selectedValues = Object.values(optionGroups).map((group) => {
      const selectedInput = group.find((input) => input.checked);
      return selectedInput
        ? selectedInput.nextElementSibling.innerText.toLowerCase().trim()
        : "";
    });

    const result = selectedValues.join(" / ").toLowerCase();

    let variantFound = false;

    // Check for matching variant in the select dropdown
    for (let i = 0; i < options.length; i++) {
      const option = options[i];
      const optionValue = option.value;
      const optionInnerText = option.innerText.toLowerCase().trim();

      if (optionInnerText === result) {
        variantFound = true;
        variantInput.value = optionValue;

        // Enable or disable the button based on availability
        if (option.hasAttribute("disabled")) {
          addToCartButton.disabled = true;
        } else {
          addToCartButton.disabled = false;
        }
        return; // Exit once the matching variant is found
      }
    }

    // If no matching variant is found or none is available, disable the button
    if (!variantFound) {
      variantInput.value = "";
      addToCartButton.disabled = true;
    }
  }

  // Attach event listeners to all inputs
  Object.values(optionGroups).forEach((group) => {
    group.forEach((input) => {
      input.addEventListener("change", updateVariantIdAndButtonState);
    });
  });

  // Initial update on page load
  updateVariantIdAndButtonState();
});
*/
/*
document.addEventListener("DOMContentLoaded", function () {
  const inputs = Array.from(
    document.querySelectorAll(".variant_groups input[type=radio]")
  );
  const select = document.querySelector(".variant_groups select");
  const options = select.children;
  const variantInput = document.getElementById("product_variant");

  // Group inputs by their `name` attribute
  const optionGroups = inputs.reduce((groups, input) => {
    const groupName = input.name;
    if (!groups[groupName]) {
      groups[groupName] = [];
    }
    groups[groupName].push(input);
    return groups;
  }, {});

  // Function to update the variant ID
  function updateVariantId() {
    const selectedValues = Object.values(optionGroups).map((group) => {
      const selectedInput = group.find((input) => input.checked);
      return selectedInput
        ? selectedInput.nextElementSibling.innerText.toLowerCase().trim()
        : "";
    });

    const result = selectedValues.join(" / ").toLowerCase();

    // Find matching option in the select dropdown
    for (let i = 0; i < options.length; i++) {
      const optionValue = options[i].value;
      const optionInnerText = options[i].innerText.toLowerCase().trim();

      if (optionInnerText === result) {
        variantInput.value = optionValue;
        return; // Exit loop once found
      }
    }

    // If no match is found, clear the variant input
    variantInput.value = "";
  }

  // Attach event listeners to all inputs
  Object.values(optionGroups).forEach((group) => {
    group.forEach((input) => {
      input.addEventListener("change", updateVariantId);
    });
  });

  // Initial update on page load
  updateVariantId();
});
*/
/*
var inputs = Array.from(document.querySelectorAll('.variant_groups input[type=radio]'));
  var sizeInputs = inputs.slice(0, inputs.length / 2);
  var colorInputs = inputs.slice(inputs.length / 2);
  var select = document.querySelector('.variant_groups select');
  var options = select.children;
  var selectedSize = sizeInputs[0].nextElementSibling.innerText.toLowerCase().trim();
  var selectedColor = colorInputs[0].nextElementSibling.innerText.toLowerCase().trim();
  var result = String(selectedSize + ' / ' + selectedColor).toLowerCase();
  var id = options[0].value;
  document.getElementById('product_variant').value = id;

  for (let i = 0; i < sizeInputs.length; i++) {
   let input = sizeInputs[i];
   input.addEventListener('change', function () {
    for (let i = 0; i < sizeInputs.length; i++) {
     let input = sizeInputs[i];
     if (input.checked) {
      selectedSize = input.nextElementSibling.innerText.toLowerCase().trim();
      result = String(selectedSize + ' / ' + selectedColor).toLowerCase();
      for (let i = 0; i < options.length; i++) {
       const optionValue = options[i].value;
       const optionInnerText = options[i].innerText.toLowerCase().trim();

       if (optionInnerText === result) {
        id = optionValue;
        document.getElementById('product_variant').value = id;
       }
      }
     }
    }
   })
  }
  for (let i = 0; i < colorInputs.length; i++) {
   let input = colorInputs[i];
   input.addEventListener('change', function () {
    for (let i = 0; i < colorInputs.length; i++) {
     let input = colorInputs[i];
     if (input.checked) {
      selectedColor = input.nextElementSibling.innerText.trim();
      result = String(selectedSize + ' / ' + selectedColor).toLowerCase();
      document.getElementById('product_variant').value = result;
      for (let i = 0; i < options.length; i++) {
       const optionValue = options[i].value;
       const optionInnerText = options[i].innerText.toLowerCase().trim();

       if (optionInnerText === result) {
        id = optionValue;
        document.getElementById('product_variant').value = id;
       }

      }

     }
    }
   })
  };
*/
// ----------------- Get cart details -------------\\
// function get_cart_details() {
//   $.getJSON("/cart.js", function (cart) {
//     // The cart data
//     var drawer_item_html = "";
//     var cart_items = cart.items;
//     $(".cart-drawer__total-amount").text(cart_subtotal);
//     // Section render
//     fetch("/?section_id=cart-drawyer")
//       .then((response) => response.text())
//       .then((cartData) => {
//         var cart_html = $(cartData);
//         var cart_items = $(".cart-drawer__content .cart-drawer__item", cart_html);
//         var cart_subtotal = $(".cart-drawer__total-amount", cart_html).text();
//         $(".cart-drawer__content").html(cart_items);
//         $(".cart-drawer__total-amount").text(cart_subtotal);
//         jQuery('body').addClass('drawer-open');
//       });
//   });
// };
